if (!customElements.get('mdiy-banner')) {
  customElements.define('mdiy-banner', class extends HTMLElement {
    connectedCallback() {
      this.abort = new AbortController();
      const options = { signal: this.abort.signal };
      this.slides = [...this.querySelectorAll('[data-slide]')];
      this.dots = [...this.querySelectorAll('[data-dot]')];
      this.index = 0; this.paused = false; this.hovered = false; this.focused = false; this.editorSelected = false;
      this.reduced = matchMedia('(prefers-reduced-motion: reduce)');
      this.pauseButton = this.querySelector('[data-pause]');
      if (this.slides.length < 2) return;
      this.querySelector('.mdiy-banner__controls').hidden = false;
      this.querySelector('[data-prev]').addEventListener('click', () => this.show(this.index - 1, true), options);
      this.querySelector('[data-next]').addEventListener('click', () => this.show(this.index + 1, true), options);
      this.dots.forEach((dot, i) => dot.addEventListener('click', () => this.show(i, true), options));
      this.pauseButton.addEventListener('click', () => { this.paused = !this.paused; this.schedule(); }, options);
      this.addEventListener('mouseenter', () => { this.hovered = true; this.schedule(); }, options);
      this.addEventListener('mouseleave', () => { this.hovered = false; this.schedule(); }, options);
      this.addEventListener('focusin', () => { this.focused = true; this.schedule(); }, options);
      this.addEventListener('focusout', () => { queueMicrotask(() => { this.focused = this.contains(document.activeElement); this.schedule(); }); }, options);
      this.addEventListener('keydown', e => {
        if (e.key !== 'ArrowLeft' && e.key !== 'ArrowRight') return;
        e.preventDefault(); this.show(this.index + (e.key === 'ArrowLeft' ? -1 : 1), true);
      }, options);
      this.addEventListener('touchstart', e => { this.touch = [e.changedTouches[0].clientX, e.changedTouches[0].clientY]; }, { ...options, passive:true });
      this.addEventListener('touchend', e => {
        if (!this.touch) return;
        const dx = e.changedTouches[0].clientX - this.touch[0], dy = e.changedTouches[0].clientY - this.touch[1];
        if (Math.abs(dx) > 50 && Math.abs(dx) > Math.abs(dy) * 1.5) this.show(this.index + (dx < 0 ? 1 : -1), true);
        this.touch = null;
      }, { ...options, passive:true });
      document.addEventListener('visibilitychange', () => this.schedule(), options);
      this.reduced.addEventListener('change', () => this.schedule(), options);
      document.addEventListener('shopify:block:select', e => {
        const i = this.slides.findIndex(slide => slide.dataset.blockId === e.detail.blockId);
        if (i < 0) return;
        this.editorSelected = true; this.show(i, true);
      }, options);
      document.addEventListener('shopify:block:deselect', () => { this.editorSelected = false; this.schedule(); }, options);
      this.schedule();
    }
    show(index, announce = false) {
      const next = (index + this.slides.length) % this.slides.length;
      if (this.slides[this.index].contains(document.activeElement)) this.dots[next].focus();
      this.index = next;
      this.slides.forEach((slide, i) => { slide.hidden = i !== next; slide.inert = i !== next; });
      this.dots.forEach((dot, i) => dot.setAttribute('aria-current', String(i === next)));
      if (announce) this.querySelector('[data-status]').textContent = `Banner ${next + 1} of ${this.slides.length}`;
      this.schedule();
    }
    schedule() {
      clearTimeout(this.timer);
      if (!this.isConnected || !this.pauseButton) return;
      const autoEnabled = this.dataset.autoplay === 'true' && !this.reduced.matches;
      this.pauseButton.hidden = !autoEnabled;
      this.pauseButton.textContent = this.paused ? '▶' : 'Ⅱ';
      this.pauseButton.setAttribute('aria-label', this.paused ? 'Play slideshow' : 'Pause slideshow');
      this.pauseButton.setAttribute('aria-pressed', String(this.paused));
      if (!autoEnabled || this.paused || this.hovered || this.focused || this.editorSelected || document.hidden) return;
      this.timer = setTimeout(() => this.show(this.index + 1), Math.max(4000, Number(this.dataset.interval) || 6000));
    }
    disconnectedCallback() { clearTimeout(this.timer); this.abort?.abort(); }
  });
}
